const { PRODUCTION, CN } = require('../constant');
const config = require('./config');

module.exports = {
  ...config,
  buildEnv: PRODUCTION,
  site: CN,
};
